import React from "react";
import { Navbar, Nav, Container, Badge, NavDropdown } from "react-bootstrap";
import { FaShoppingCart, FaUser } from "react-icons/fa";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/usersApiSlice";
import { logout } from "../slices/authSlice";
import logo from "../assets/images/logo.png";

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.error("Failed to logout:", error);
     }
  }

  return (
    <header>
      <Navbar bg="primary" variant="dark" expand="lg" collapseOnSelect>
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img
                src={logo}
                alt="fofog-logo"
                style={{ width: "130px", height: "auto" }}
              />
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <LinkContainer to="/cart">
                <Nav.Link className="cart-icon-container">
                  <FaShoppingCart className="cart-icon" />
                  {cartItems.length > 0 && (
                    <Badge pill bg="danger" className="cart-badge" style={{ marginRight: '45px' }}>
                      {cartItems.length}
                      {/* {cartItems.reduce((acc, item) => acc + item.qty, 0)} */}
                    </Badge>
                  )}
                  <span className="cart-text">Cart</span>
                </Nav.Link>
              </LinkContainer>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>Profiel</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/orders">
                    <NavDropdown.Item>Mijn Bestellingen</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>Uitloggen</NavDropdown.Item>
              </NavDropdown>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link>
                    <FaUser /> Inloggen
                  </Nav.Link>
                </LinkContainer>
              )}
              {/* Admin Links */}
              {userInfo && userInfo.isAdmin && (
                <NavDropdown title='Admin' id='adminmenu'>
                    {/* <NavDropdown.Item as={Link} to='/admin/productlist'>
                        Products
                    </NavDropdown.Item> */}
                    <LinkContainer to='/admin/orderlist'>
                        <NavDropdown.Item>Bestellingen</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to='/admin/userlist'>
                        <NavDropdown.Item>Gebruikers</NavDropdown.Item>
                    </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Custom CSS for Badge Positioning */}
      <style>
        {`
          .cart-icon-container {
            position: relative;
            display: flex;
            align-items: center;
          }

          .cart-icon {
            font-size: 1.5rem;
            position: relative;
          }

          .cart-badge {
            position: absolute;
            top: -5px;
            right: -10px;
            font-size: 12px;
            padding: 5px;
            border-radius: 50%;
          }

          .cart-text {
            margin-left: 5px;
          }
        `}
      </style>
    </header>
  );
};

export default Header;
